/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Platform } from './Platform';
import {
    PlatformFromJSON,
    PlatformFromJSONTyped,
    PlatformToJSON,
} from './Platform';

/**
 * 
 * @export
 * @interface BulkSendPushNotificationRequest
 */
export interface BulkSendPushNotificationRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkSendPushNotificationRequest
     */
    recipientLookupIds?: Array<string>;
    /**
     * 
     * @type {Platform}
     * @memberof BulkSendPushNotificationRequest
     */
    audience?: Platform;
    /**
     * Construct a type with a set of properties K of type T
     * @type {{ [key: string]: string; }}
     * @memberof BulkSendPushNotificationRequest
     */
    data?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof BulkSendPushNotificationRequest
     */
    body: string;
    /**
     * 
     * @type {string}
     * @memberof BulkSendPushNotificationRequest
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof BulkSendPushNotificationRequest
     */
    category: string;
    /**
     * A UUID in its canonical hyphenated form, in either letter case.
     * @type {string}
     * @memberof BulkSendPushNotificationRequest
     */
    id: string;
}



/**
 * Check if a given object implements the BulkSendPushNotificationRequest interface.
 */
export function instanceOfBulkSendPushNotificationRequest(value: object): value is BulkSendPushNotificationRequest {
    if (!('body' in value) || value['body'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('category' in value) || value['category'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function BulkSendPushNotificationRequestFromJSON(json: any): BulkSendPushNotificationRequest {
    return BulkSendPushNotificationRequestFromJSONTyped(json, false);
}

export function BulkSendPushNotificationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkSendPushNotificationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'recipientLookupIds': json['recipientLookupIds'] == null ? undefined : json['recipientLookupIds'],
        'audience': json['audience'] == null ? undefined : PlatformFromJSON(json['audience']),
        'data': json['data'] == null ? undefined : json['data'],
        'body': json['body'],
        'title': json['title'],
        'category': json['category'],
        'id': json['id'],
    };
}

export function BulkSendPushNotificationRequestToJSON(value?: BulkSendPushNotificationRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'recipientLookupIds': value['recipientLookupIds'],
        'audience': PlatformToJSON(value['audience']),
        'data': value['data'],
        'body': value['body'],
        'title': value['title'],
        'category': value['category'],
        'id': value['id'],
    };
}

